var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetttuecher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.616,
    height: 54.616,
    viewBox: "0 0 54.616 54.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_123",
    x: 0,
    y: 0,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "betttuecher",
    transform: "translate(8.012 4.888)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.01, -4.89)",
    filter: "url(#Pfad_123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_123-2",
    "data-name": "Pfad 123",
    d: "M106.616,72.308A18.308,18.308,0,1,0,88.308,90.616a18.308,18.308,0,0,0,18.308-18.308",
    transform: "translate(-61 -48)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_69",
    "data-name": "Rechteck 69",
    width: 18,
    height: 3,
    transform: "translate(12.378 34.716)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_70",
    "data-name": "Rechteck 70",
    width: 4,
    height: 3,
    transform: "translate(34.378 34.716)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_71",
    "data-name": "Rechteck 71",
    width: 4,
    height: 18,
    transform: "translate(34.378 12.716)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_184",
    "data-name": "Pfad 184",
    d: "M14.791,289.768H6V286H17.93v3.767Z",
    transform: "translate(-5.529 -263.553)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_185",
    "data-name": "Pfad 185",
    d: "M289.767,14.791v3.14H286V6h3.767Z",
    transform: "translate(-263.552 -5.529)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_186",
    "data-name": "Pfad 186",
    d: "M6,238H17.93v3.767H6Z",
    transform: "translate(-5.529 -219.32)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_187",
    "data-name": "Pfad 187",
    d: "M241.767,14.791v3.14H238V6h3.767Z",
    transform: "translate(-219.32 -5.529)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_72",
    "data-name": "Rechteck 72",
    width: 4,
    height: 4,
    transform: "translate(34.378 30.716)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_73",
    "data-name": "Rechteck 73",
    width: 18,
    height: 4,
    transform: "translate(12.378 30.716)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_74",
    "data-name": "Rechteck 74",
    width: 4,
    height: 3,
    transform: "translate(30.378 34.716)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_75",
    "data-name": "Rechteck 75",
    width: 4,
    height: 18,
    transform: "translate(30.378 12.716)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_188",
    "data-name": "Pfad 188",
    d: "M176.209,158v18.209H158v-15.7A2.511,2.511,0,0,1,160.512,158h15.7Z",
    transform: "translate(-145.599 -145.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_189",
    "data-name": "Pfad 189",
    d: "M6,8.512A2.511,2.511,0,0,1,8.512,6h15.7V17.93H20.442a2.511,2.511,0,0,0-2.512,2.512v3.767H6V8.512Z",
    transform: "translate(-5.529 -5.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_190",
    "data-name": "Pfad 190",
    d: "M178.215,152H154.983A2.986,2.986,0,0,0,152,154.983v23.232a.471.471,0,0,0,.471.471h25.744a.471.471,0,0,0,.471-.471V152.471a.471.471,0,0,0-.471-.471m-7.064,19.151h2.826v2.826h-2.826Zm2.826,6.593h-2.826v-2.826h2.826Zm-21.035-6.593h17.267v2.826H152.942Zm18.209-18.209h2.826v17.267h-2.826Zm3.767,18.209h2.826v2.826h-2.826Zm2.826-.942h-2.826V152.942h2.826Zm-22.761-17.267h15.227v17.267H152.942V154.983a2.043,2.043,0,0,1,2.041-2.041m-2.041,21.977h17.267v2.826H152.942Zm21.977,0h2.826v2.826h-2.826Z",
    transform: "translate(-140.07 -140.07)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_191",
    "data-name": "Pfad 191",
    d: "M9.262,19.151a.471.471,0,0,0,0-.942H.942V2.983A2.043,2.043,0,0,1,2.983.942H18.209v8.32a.471.471,0,1,0,.942,0V.942h2.826v8.32a.471.471,0,1,0,.942,0V.942h2.826v8.32a.471.471,0,1,0,.942,0V.471A.471.471,0,0,0,26.215,0H2.983A2.986,2.986,0,0,0,0,2.983V26.215a.471.471,0,0,0,.471.471H9.262a.471.471,0,0,0,0-.942H.942V22.918h8.32a.471.471,0,1,0,0-.942H.942V19.151Z",
    transform: "translate(0 0)",
    fill: "#303e58"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetttuecher);
export default __webpack_public_path__ + "static/media/betttuecher.d398385b0191b630daba2b243c53fdf2.svg";
export { ForwardRef as ReactComponent };